import React from 'react';
import { string, node, func } from 'prop-types';
import { Link } from '@fiverr-private/typography';
import { widgetType } from '../../utils/propTypes';
import { resolveTrackingLink } from '../../utils/trackingLink';
import { useLandingPage } from '../../hooks/useLandingPage';

export const TrackingLink = (props) => {
    const {
        className,
        onClick = Function.prototype,
        slug = '',
        afp,
        afp1,
        afp2,
        afp3,
        affiliateId,
        utmCampaign,
        widgetType,
        brand,
        children,
    } = props;

    const landingPage = useLandingPage(slug);
    const trackingLink = resolveTrackingLink({
        affiliateId,
        afp,
        afp1,
        afp2,
        afp3,
        brand,
        utmCampaign,
        landingPage,
        widgetType,
    });

    return className ? (
        <a className={className} onClick={onClick} target="_blank" rel="noreferrer sponsored" href={trackingLink}>
            {children}
        </a>
    ) : (
        <Link onClick={onClick} target="_blank" rel="noreferrer sponsored" decoration="none">
            {children}
        </Link>
    );
};

TrackingLink.propTypes = {
    className: string,
    onClick: func,
    slug: string,
    afp: string.isRequired,
    afp1: string.isRequired,
    afp2: string.isRequired,
    afp3: string.isRequired,
    affiliateId: string.isRequired,
    utmCampaign: string.isRequired,
    widgetType,
    brand: string.isRequired,
    children: node,
};
